import { Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Pagination, Box, IconButton, Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import CopyableText from '../SharedArea/CopyableText';

const UsersTable = ({ users, total, page, limit, setPage, onEdit, onArchive, visibleFields }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <TableContainer
                component={Paper}
                sx={{
                    minWidth: 1000,
                    overflow: 'auto',
                    flex: 1,
                    borderRadius: 0,
                    boxShadow: 'none'
                }}
            >
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            {visibleFields.includes('profilePicture') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תמונת פרופיל</TableCell>}
                            {visibleFields.includes('_id') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>ID</TableCell>}
                            {visibleFields.includes('firstName') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>שם פרטי</TableCell>}
                            {visibleFields.includes('lastName') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>שם משפחה</TableCell>}
                            {visibleFields.includes('email') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>אימייל</TableCell>}
                            {visibleFields.includes('password') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>סיסמה</TableCell>}
                            {visibleFields.includes('role') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תפקיד</TableCell>}
                            {visibleFields.includes('subscriptionLevel') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>גישה</TableCell>}
                            {visibleFields.includes('serial') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>קוד סיריאל</TableCell>}
                            {visibleFields.includes('goalId') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>כיתה</TableCell>}
                            {visibleFields.includes('createdAt') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תאריך יצירה</TableCell>}
                            {visibleFields.includes('typeOfDictionary') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>סוג מילון</TableCell>}
                            {visibleFields.includes('archive') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>ארכיון</TableCell>}
                            {visibleFields.includes('permissionProfile') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>פרופיל הרשאות</TableCell>}
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>פעולות</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((user) => (
                            <TableRow key={user._id}>
                                {visibleFields.includes('profilePicture') && (
                                    <TableCell>
                                        {user.profilePicture ? (
                                            <img
                                                src={user.profilePicture}
                                                alt="שגיאה"
                                                style={{ width: 50, height: 50, borderRadius: '50%' }}
                                            />
                                        ) : (
                                            <div style={{ width: 50, height: 50, borderRadius: '50%', backgroundColor: '#ccc' }} />
                                        )}
                                    </TableCell>
                                )}
                                {visibleFields.includes('_id') && <TableCell>{user._id}</TableCell>}
                                {visibleFields.includes('firstName') && <TableCell sx={{ maxWidth: 200, overflowWrap: 'break-word', wordBreak: 'break-word' }}>{user.firstName}</TableCell>}
                                {visibleFields.includes('lastName') && <TableCell sx={{ maxWidth: 200, overflowWrap: 'break-word', wordBreak: 'break-word' }}>{user.lastName}</TableCell>}
                                {visibleFields.includes('email') && (
                                    <TableCell sx={{ maxWidth: 300, overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                                        {user.email && <CopyableText text={user.email} iconPosition="left" />}
                                    </TableCell>
                                )}
                                {visibleFields.includes('password') && (
                                    <TableCell sx={{ maxWidth: 200, overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                                        {user.password && <CopyableText text={user.password} iconPosition="left" />}
                                    </TableCell>
                                )}
                                {visibleFields.includes('role') && (
                                    <TableCell>
                                        {({
                                            teacher: 'מורה',
                                            student: 'תלמיד',
                                            admin: 'מנהל',
                                            withoutRole: 'ללא תפקיד'
                                        }[user.role] ?? user.role)}
                                    </TableCell>
                                )}
                                {visibleFields.includes('subscriptionLevel') && (
                                    <TableCell>
                                        {({
                                            [-2]: 'קוד סיריאל',
                                            [-1]: 'עובד החברה',
                                            0: 'חסום',
                                            1: 'משלם'
                                        }[user.subscriptionLevel] ?? user.subscriptionLevel)}
                                    </TableCell>
                                )}
                                {visibleFields.includes('serial') && (
                                    <TableCell>
                                        {user.serial?.serial && (
                                            <CopyableText
                                                text={user.serial.serial}
                                                iconPosition="left"
                                                linkTo={`/access-serial?serial=${user.serial.serial}`}
                                            />
                                        )}
                                    </TableCell>
                                )}
                                {visibleFields.includes('goalId') && (
                                    (Array.isArray(user.goalId)) ? <TableCell>{user.goalId.map(goal => (<><Link to={`/classroom?goalId=${goal}`}>{goal}</Link><> </></>))}</TableCell> :
                                    <TableCell>{user.goalId ? JSON.stringify(user.goalId) : ''}</TableCell>
                                )}
                                {visibleFields.includes('createdAt') && (
                                    <TableCell sx={{ direction: 'rtl' }}>
                                        {new Date(user.createdAt).toLocaleString('he-IL', {
                                            timeZone: 'Asia/Jerusalem',
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </TableCell>
                                )}
                                {visibleFields.includes('typeOfDictionary') && (
                                    <TableCell>
                                        {({
                                            universal: 'אוניברסלי',
                                            olami: 'עולמי'
                                        }[user.typeOfDictionary] ?? user.typeOfDictionary)}
                                    </TableCell>
                                )}
                                {visibleFields.includes('archive') && (
                                    <TableCell>{user.archive ? 'כן' : 'לא'}</TableCell>
                                )}
                                {visibleFields.includes('permissionProfile') && (
                                    <TableCell>
                                        {user.permissionProfile?.name ? (
                                            <Typography
                                                variant="body2"
                                                color="primary"
                                                component={Link}
                                                to={`/profiles?name=${user.permissionProfile.name}`}
                                            >
                                                {user.permissionProfile.name}
                                            </Typography>
                                        ) : (
                                            ''
                                        )}
                                    </TableCell>
                                )}
                                <TableCell sx={{ minWidth: 120 }}>
                                    <IconButton onClick={() => onEdit(user)}>
                                        <EditIcon />
                                    </IconButton>

                                    {user.archive ? (
                                        <IconButton onClick={() => onArchive(user, false)} sx={{ color: 'red' }}>
                                            <UnarchiveIcon />
                                        </IconButton>
                                    ) : (
                                        <IconButton onClick={() => onArchive(user, true)} sx={{ color: 'green' }}>
                                            <ArchiveIcon />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={0} py={1} display="flex" justifyContent="center">
                <Pagination
                    count={Math.ceil(total / limit)}
                    page={page}
                    onChange={(e, val) => setPage(val)}
                    color="primary"
                />
            </Box>
        </Box>
    );
};

export default UsersTable;